import { FC } from "react";

import { FullWidthVStack } from "@components/common";
import responsiveStyle from "@lib/theme/responsiveStyle";

import { OrderFields, DeliveryMethod } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";
import ReceiverAddressFormFields from "../common/ReceiverAddressFormFields";
import ReceiverLockerFormFields from "../common/ReceiverLockerFormFields";
import SenderDetails from "./SenderDetails";

type TShipmentFormFieldsProps = {
  onOpenLockersMap: () => void;
};

const ShipmentFormFields: FC<TShipmentFormFieldsProps> = ({ onOpenLockersMap }) => {
  const {
    values: { [OrderFields.DELIVERY_METHOD]: deliveryMethod },
  } = useOrderFormik();

  return (
    <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "1.5rem" })}>
      <SenderDetails onOpenLockersMap={onOpenLockersMap} />
      {deliveryMethod === DeliveryMethod.PudoToPudo && <ReceiverLockerFormFields />}
      {deliveryMethod === DeliveryMethod.PudoToDoor && <ReceiverAddressFormFields />}
    </FullWidthVStack>
  );
};
export default ShipmentFormFields;
